import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Container } from '../../components';
import styles from './keto-logo.module.css';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoLogo() {
  return (
    <section className={styles.logo}>
      <Container>
        <AnimationOnScroll
          offset={400}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInUp"
          className={styles.logo_inner}
        >
          <div className={styles.logo_start}>
            <Image
              alt="keto kitchen logo icon"
              src="/keto/logo-images/logo.png"
              width={513}
              height={250}
            />
          </div>
          <div className={styles.logo_end}>
            <KetoTypography
              className={styles.logo_title}
              tag="h2"
              variant={KetoTypographyVariant.HEADLINE_1}
            >
              About Logo
            </KetoTypography>
            <KetoPaper>
              <KetoTypography
                className={styles.logo_text}
                variant={KetoTypographyVariant.BODY_2}
                tag="p"
              >
                The logo is a combination of the icons set and Bellota font. You
                can find the logo as a sticker on some merch materials below.
              </KetoTypography>
            </KetoPaper>
          </div>
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
